import axios from 'axios';
import {rawreq, req, reqFormData} from './axiosFun';

// 登录接口
export const login = (params) => { return rawreq("post", "/api/login", params) };
// 退出接口
export const logout = (params) => { return req("get", "/api/logout", params) };

// 获取用户菜单
export const menu = (params) => { return axios.get("/api/menu?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 用户管理
 **/
// 用户管理-获取用户列表
export const userList = (params) => { return rawreq("post", "/api/user/getUserList", params) };
// 用户管理- 新增用户
export const addUser = (params) => { return rawreq("post", "/api/user/addUser", params) };
// 用户管理- 修改用户
export const editUser = (params) => { return rawreq("post", "/api/user/editUser", params) };
// 用户管理- 删除用户
export const removeUser = (params) => { return rawreq("post", "/api/user/removeUser", params) };
// 用户管理- 解锁用户
export const unLockUser = (params) => { return req("post", "/api/user/unLockUser", params) };
// 用户管理- 用户详情
export const userDetail = (params) => { return req("get", "/api/user/getUserDetail?userSeqId=" + params, {}) };
// 用户管理- 获取对应用户 绑定的 角色
export const getUserRoleList = (params) => { return req("get", "/api/user/getUserRoleList?userSeqId=" + params, {}) };
// 角色管理- 给用户 绑定 角色
export const addFillRole = (params) => { return rawreq("post", "/api/user/fillRole?userSeqId=" + params.userSeqId, JSON.stringify(params.roleIds)) };

// 用户管理- 管理员为其他用户修改密码
export const editOtherUserPassword = (params) => { return rawreq("post", "/api/user/editOtherUserPassword", params) };

// 用户管理- 当前登录用户 修改 自己的基础信息
export const editUserSelfBasicInfo = (params) => { return rawreq("post", "/api/user/editUserSelfBasicInfo", params) };
// 用户管理- 当前登录用户 修改 自己的密码
export const editUserSelfPassword = (params) => { return rawreq("post", "/api/user/editUserSelfPassword", params) };


/**
 * 角色管理
 **/
// 角色管理- 获取角色列表
export const roleList = (params) => { return rawreq("post", "/api/role/getRolePage", params) };
// 角色管理- 新增角色
export const createRole = (params) => { return rawreq("post", "/api/role/createRole", params) };
// 角色管理- 修改角色
export const editRole = (params) => { return rawreq("post", "/api/role/editRole", params) };
// 角色管理- 销毁角色
export const destroyRole = (params) => { return rawreq("post", "/api/role/destroyRole", params) };

// 角色管理- 获取全部 菜单权限
export const getAllRes = (params) => { return req("get", "/api/res/getAllRes", params) };
// 角色管理- 获取指定角色 菜单权限
export const getResList = (params) => { return req("get", "/api/role/getRoleResList?roleSeqId=" + params, {}) };
// 角色管理- 给角色 新增菜单权限
export const addFillRes = (params) => { return rawreq("post", "/api/role/fillRes?roleSeqId=" + params.roleSeqId, JSON.stringify(params.resSeqIds)) };


// 角色管理-菜单权限（获取）
export const RoleRightTree = (params) => { return axios.get("/api/RoleRight/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 角色管理-菜单权限（保存）
export const RoleRightSave = (params) => { return req("post", "/api/RoleRight/save", params) };


/**
 * 营销渠道
 **/
// 营销渠道-获取 营销渠道列表
export const getMarketingChannelList = (params) => { return rawreq("post", "/api/marketingChannel/getMarketingChannelList", params) };
// 营销渠道- 添加营销渠道
export const addMarketingChannel = (params) => { return rawreq("post", "/api/marketingChannel/addMarketingChannel", params) };
// 营销渠道- 修改营销渠道
export const editMarketingChannel = (params) => { return rawreq("post", "/api/marketingChannel/editMarketingChannel", params) };
// 营销渠道- 删除营销渠道
export const deleteMarketingChannel = (params) => { return rawreq("post", "/api/marketingChannel/deleteMarketingChannel", params) };


/**
 *  学习平台
 **/
// 学习平台-获取 学习平台列表
export const getLearnPlatformList = (params) => { return rawreq("post", "/api/learnPlatform/getLearnPlatformList", params) };
// 学习平台- 添加学习平台
export const addLearnPlatform = (params) => { return rawreq("post", "/api/learnPlatform/addLearnPlatform", params) };
// 学习平台- 修改学习平台
export const editLearnPlatform = (params) => { return rawreq("post", "/api/learnPlatform/editLearnPlatform", params) };
// 学习平台- 删除学习平台
export const deleteLearnPlatform = (params) => { return rawreq("post", "/api/learnPlatform/deleteLearnPlatform", params) };


/*
*  机构管理
* */
// 机构管理 详情
export const queryOrg = (params) => { return req("post", "/api/org/queryOrg", params) };
// 机构管理 修改
export const updateOrg = (params) => { return req("post", "/api/org/updateOrg", params) };


/**
 * 统计分析
 **/
// 统计分析- 查询报表数据
export const findReportData = (params) => { return rawreq("post", "/api/report/queryByType", params) };


/**
 *  教室管理
 **/
// 列表
export const getRoomList = (params) => { return req("post", "/api/room/queryByPage", params) };
// 新增
export const addRoom = (params) => { return req("post", "/api/room/add", params) };
// 编辑
export const editRoom = (params) => { return req("post", "/api/room/edit", params) };
// 删除
export const deleteRoomById = (id) => { return rawreq("get", "/api/room/deleteById?id=" + id, {}) };
// 获取高德的key
export const getGdKey = (id) => { return rawreq("get", "/api/common/getGdKey", {}) };

/**
 *  课程表模板管理
 **/
// 列表
export const getCourseMbList = (params) => { return req("post", "/api/courseMb/queryByPage", params) };
// 新增
export const addCourseMb = (params) => { return rawreq("post", "/api/courseMb/add", params) };
// 编辑
export const editCourseMb = (params) => { return rawreq("post", "/api/courseMb/edit", params) };
// 详情
export const queryCourseMbById = (id) => { return rawreq("get", "/api/courseMb/queryById?id=" + id, {}) };
// 删除
export const deleteCourseMbById = (id) => { return rawreq("get", "/api/courseMb/deleteById?id=" + id, {}) };

/*
*  系统设置
* */
// 获取设置项列表--无需分页，平铺到页面
export const querySystemSzList = (params) => { return req("post", "/api/common/querySystemSzList", params) };
// 修改设置项
export const updateSystemSz = (params) => { return req("post", "/api/common/updateSystemSz", params) };





// WEBPACK FOOTER //
// ./src/api/userMG.js